<template>
  <div
    class="tw-flex tw-w-full tw-items-center tw-justify-center tw-px-[16px] tw-pb-[120px] tw-pt-[16px]"
  >
    <div class="tw-flex tw-w-full tw-max-w-[400px] tw-flex-col tw-items-center">
      <div class="tw-aspect-[400/273] tw-w-full tw-max-w-[400px]">
        <img
          :src="cdnAsset('images/student/enquiries-empty.png')"
          alt=""
          loading="lazy"
          decoding="async"
          class="tw-block tw-h-full tw-w-full tw-object-contain"
        />
      </div>

      <template v-if="isLoggedInStudent">
        <h2
          class="tw-my-[8px] tw-p-0 tw-text-center tw-text-[16px] tw-font-[600] tw-leading-[24px] tw-text-[#3B4143]"
        >
          No enquiries yet
        </h2>

        <p
          class="tw-mb-[24px] tw-p-0 tw-text-center tw-text-[14px] tw-font-[400] tw-leading-[21px] tw-text-[#6B7280]"
        >
          Once you enquire to a property it will show here. No more hunting around
          in your inbox to remember which properties you've enquired to and when.
        </p>

        <button
          type="button"
          class="tw-flex tw-min-h-[50px] tw-w-full tw-cursor-pointer tw-items-center tw-justify-center tw-gap-2 tw-rounded-full tw-bg-uhblue-500 tw-px-6 tw-py-2 tw-text-[16px] tw-font-[600] tw-leading-[21px] tw-text-white hover:tw-bg-uhblue-700 focus-visible:tw-bg-uhblue-700 focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-[#61B3E5] focus-visible:tw-ring-offset-2"
          @click="studentStore.handleReturnToSearchPage()"
        >
          <MagnifyingGlass /> Back to search results
        </button>
      </template>

      <template v-else>
        <h2
          class="tw-my-[8px] tw-p-0 tw-text-center tw-text-[16px] tw-font-[600] tw-leading-[24px] tw-text-[#3B4143]"
        >
          You need to login or create a profile
        </h2>

        <p
          class="tw-mb-[24px] tw-p-0 tw-text-center tw-text-[14px] tw-font-[400] tw-leading-[21px] tw-text-[#6B7280]"
        >
          After logging in you can see all your enquiries here. No more hunting around
          in your inbox to remember which properties you've enquired to and when.
        </p>

        <a
          href="/account/login"
          class="tw-mx-auto tw-flex tw-w-full tw-max-w-[328px] tw-flex-1 tw-items-center tw-justify-center tw-gap-[8px] tw-self-stretch tw-rounded-[30px] tw-bg-[#F48831] tw-px-[24px] tw-py-[8px] hover:tw-bg-[#E16B0C] focus-visible:tw-bg-[#E16B0C] focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-[#61B3E5] focus-visible:tw-ring-offset-2 disabled:tw-cursor-not-allowed disabled:tw-bg-[#efefef] disabled:hover:tw-bg-[#efefef]"
        >
          <span
            class="tw-font-inter tw-text-center tw-text-[16px] tw-font-bold tw-leading-[150%] tw-text-white"
          >
            Log in
          </span>
        </a>

        <span class="tw-mt-[16px] tw-text-[16px]">
          Don't have a profile?

          <a href="/account/sign-up" class="tw-font-[700] hover:tw-text-[#0090C8] focus-visible:tw-text-[#0090C8] focus-visible:tw-rounded-[2px] focus-visible:tw-ring-2 focus-visible:tw-ring-[#61B3E5] focus-visible:tw-ring-offset-2"> Sign up </a>
        </span>
      </template>
    </div>
  </div>
</template>

<script>
import MagnifyingGlass from '@components/Student/SVG/MagnifyingGlass.vue';
import { useStudentStore } from '@js/stores/student/student';

export default {
  name: 'UserEnquiries',
  components: {
    MagnifyingGlass,
  },
  props: {
    isLoggedInStudent: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    const studentStore = useStudentStore();

    return {
      studentStore,
    };
  },
};
</script>
